module.exports = __webpack_public_path__ + "media/application/images/icons/recommended-d3cee4acf8e826db67cb2c9f234886ae.svg";